import { ButtonComponent } from "./styled.components";
export default function ButtonLogin({ text, onClick, disabled = false }) {
  return (
    <ButtonComponent onClick={onClick} disabled={disabled}>
      {text}
    </ButtonComponent>
  );
}
